import { render } from "./HeroiconsSolidVariable.vue?vue&type=template&id=46afa813"
const script = {}

import exportComponent from "/home/fran/Desarrollo/soyasi/ebim-crm/vendor/laravel/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsSolidVariable.vue"]])

export default __exports__